module.exports = __webpack_public_path__ + "img/no-venue-empty-state.91b622e1.svg";